// material-ui
import React, { useEffect, useState } from 'react';

// project imports
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';
import getDevicesAsync, { getDevicesAsyncConfig, getDeviceByIDAsync } from 'service/device-service';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Input,
    InputLabel,
    NativeSelect,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    TextField,
    TypeAction,
    Typography
} from '@mui/material';
import { gridSpacing } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import useAuth from 'hooks/useAuth';
import { getConfigAsync, updateConfigAsync } from 'service/bdr-service';

const ConfigChecker = () => {
    localStorage.setItem('currentPage', '/config-checker');

    const [content, setContent] = React.useState<ListProps>({
        title: 'Nothing Selected',
        content: { data: [], headers: [] },
        allowCSVExport: false
    });

    const [devices, setDevices] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [projects, setProjects] = useState<any[]>([]);
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [deviceID, setDeviceID] = useState<any[]>([]);
    const [configDevices, setConfigDevices] = useState<any[]>([]);

    const [selectedSN, setSelectedSN] = useState<string[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
    const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
    const [selectedDeviceID, setSelectedDeviceID] = useState<string[]>([]);

    const [searchByDevice, setSearchByDevice] = useState<boolean>(true);

    const [configVersion, setConfigVersion] = useState<any[]>([]);
    const [timeRunMode, setTimeRunMode] = useState<any[]>([]);
    const [timeDiffLastEvent, setTimeDiffLastEvent] = useState<any[]>([]);
    const [bdrTimeout, setBDRTimeout] = useState<any[]>([]);
    const [mcuSource, setMCUSource] = useState<any[]>([]);
    const [tcuSource, setTCUSource] = useState<any[]>([]);

    useEffect(() => {
        setUserName(user?.email);

        const fetchDropDowns = async () => {
            try {
                const configDeviceResponse = await getDevicesAsyncConfig();
                const devicesResponse = await getDevicesAsync();
                const customersResponse: Set<string> = new Set();
                const devicesIDResponse: Set<string> = new Set();
                const devicesIDResponseConfig: Set<string> = new Set();

                setConfigDevices(configDeviceResponse);

                setDevices(devicesResponse);

                devicesResponse.forEach((device: any) => {
                    customersResponse.add(device.Customer);
                });

                devicesResponse.forEach((device: any) => {
                    devicesIDResponse.add(device['Device ID']);
                });

                configDeviceResponse.forEach((device: any) => {
                    devicesIDResponseConfig.add(device.TCU_ID);
                });

                setDeviceID(Array.from(devicesIDResponseConfig).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));

                setCustomers(Array.from(customersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    const handleCustomerChange = (_event: any, value: string[]) => {
        setSelectedProjects([]);
        setSelectedVehicles([]);
        setSelectedSN([]);
        setSelectedCustomers(value);
        const projectsResponse: Set<string> = new Set();
        const snResponse: Set<string> = new Set();

        devices.forEach((device: any) => {
            if (value.includes(device.Customer)) {
                if (device['Project Number'] != undefined) {
                    projectsResponse.add(device['Project Number']);
                }
                snResponse.add(device['Device ID']);
            }
        });
        setProjects(Array.from(projectsResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        if (snResponse != undefined) {
            console.log(snResponse);
            setSelectedSN(Array.from(snResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        }
    };

    const handleProjectChange = (_event: any, value: string[]) => {
        setSelectedVehicles([]);
        setSelectedSN([]);
        setSelectedProjects(value);
        const vehiclesResponse: Set<string> = new Set();
        const snResponse: Set<string> = new Set();

        devices.forEach((device: any) => {
            if (selectedCustomers.includes(device.Customer) && value.includes(device['Project Number'])) {
                if (device['Vehicle ID'] != undefined) {
                    vehiclesResponse.add(device['Vehicle ID']);
                    snResponse.add(device['Device ID']);
                }
            }
        });
        setVehicles(Array.from(vehiclesResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        if (snResponse != undefined) {
            setSelectedSN(Array.from(snResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
        }
    };

    const handleVehicleChange = (_event: any, value: string[]) => {
        setSelectedSN([]);
        setSelectedVehicles(value);
        let serialNumbersResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (
                selectedCustomers.includes(device.Customer) &&
                selectedProjects.includes(device['Project Number']) &&
                value.includes(device['Vehicle ID'])
            ) {
                serialNumbersResponse.add(device['Device ID']);
            }
        });
        setSelectedSN(Array.from(serialNumbersResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    };

    const handleDeviceChange = (_event: any, value: string[]) => {
        setSelectedDeviceID(value);
        var singleValue = [value.toString()];
        setSelectedSN(singleValue);
    };

    const setSearchTrue = (_event: any) => {
        setSearchByDevice(true);
        setSelectedCustomers([]);
        setSelectedProjects([]);
        setSelectedVehicles([]);
        setSelectedSN([]);
    };

    const setSearchFalse = (_event: any) => {
        setSearchByDevice(false);
        setSelectedDeviceID([]);
        setSelectedSN([]);
    };

    const handleConfigChange = (e: any) => {
        setConfigVersion(e.target.value);
    };

    const handleTimeRunModeChange = (e: any) => {
        setTimeRunMode(e.target.value);
    };

    const handleTimeDiffLastEventChange = (e: any) => {
        setTimeDiffLastEvent(e.target.value);
    };

    const handleBDRTimeoutChange = (e: any) => {
        setBDRTimeout(e.target.value);
    };

    const handleMCUSourceChange = (e: any) => {
        setMCUSource(e.target.value);
    };

    const handleTCUSourceChange = (e: any) => {
        setTCUSource(e.target.value);
    };

    const handleUpdateConfig = async (e: any) => {
        try {
            setContent({
                title: 'Loading',
                content: { data: [], headers: [] },
                allowCSVExport: false
            });
            const response = await updateConfigAsync(
                selectedSN,
                configVersion,
                timeRunMode,
                timeDiffLastEvent,
                bdrTimeout,
                mcuSource,
                tcuSource
            );
            handleGetConfig(selectedSN);
        } catch (error) {
            setContent({
                title: 'Error',
                content: { data: [], headers: [] },
                allowCSVExport: false
            });
            console.error('Error submitting data:', error);
        }
    };

    const handleGetConfig = async (e: any) => {
        try {
            setContent({
                title: 'Loading',
                content: { data: [], headers: [] },
                allowCSVExport: false
            });
            const response = await getConfigAsync(selectedSN);

            let headers: string[] = [];

            headers = [
                'TCU_ID',
                'Config_Version',
                'Time_RunMode',
                'Time_DiffLastEvent',
                'BDR_Timeout_ms',
                'MCU_Source_ID',
                'TCU_Source_ID'
            ];
            const contentResponse: Content = {
                data: response,
                headers: headers.map((header) => {
                    return {
                        title: header,
                        value: header
                    };
                })
            };

            setContent({
                title: response.length == 0 ? 'No data was found' : 'Config',
                content: contentResponse,
                allowCSVExport: false
            });
        } catch (error) {
            setContent({
                title: 'Error',
                content: { data: [], headers: [] },
                allowCSVExport: false
            });
            console.error('Error submitting data:', error);
        }
    };

    const { logout, user } = useAuth();
    const [userName, setUserName] = useState<any>('');

    return (
        <div>
            {user?.role == 'admin' ? (
                <form>
                    <div>
                        {searchByDevice == true ? (
                            <div>
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <Grid item>
                                            <Button variant="contained" component="label" onClick={setSearchFalse}>
                                                Search by Customer
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br></br>
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard title={<span>Device</span>}>
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedDeviceID'}
                                                        disableClearable
                                                        options={deviceID}
                                                        getOptionLabel={(option: any) => option}
                                                        value={selectedDeviceID}
                                                        onChange={handleDeviceChange}
                                                        //defaultValue={[]}
                                                        style={{ width: '15rem' }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                </Grid>
                            </div>
                        ) : (
                            <div>
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <Grid item>
                                            <Button variant="contained" component="label" onClick={setSearchTrue}>
                                                Search by Device
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <br></br>
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard
                                            title={
                                                <span>
                                                    Customer <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                        >
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedCustomers'}
                                                        disableClearable
                                                        options={customers}
                                                        getOptionLabel={(option: any) => option}
                                                        value={selectedCustomers}
                                                        onChange={handleCustomerChange}
                                                        defaultValue={[]}
                                                        style={{ width: '15rem' }}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard title={<span>Project Number</span>}>
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedProjects'}
                                                        disableClearable
                                                        options={projects}
                                                        getOptionLabel={(option) => option}
                                                        value={selectedProjects}
                                                        onChange={handleProjectChange}
                                                        // defaultValue={}
                                                        style={{ width: '15rem' }}
                                                        disabled={selectedCustomers.length === 0}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={3}>
                                        <SubCard title={<span>Vehicle ID</span>}>
                                            <Grid container direction="column" spacing={3}>
                                                <Grid item>
                                                    <Autocomplete
                                                        key={'selectedVehicles'}
                                                        disableClearable
                                                        options={vehicles}
                                                        getOptionLabel={(option) => option}
                                                        value={selectedVehicles}
                                                        onChange={handleVehicleChange}
                                                        // defaultValue={}
                                                        style={{ width: '15rem' }}
                                                        disabled={selectedCustomers.length === 0 || selectedProjects.length === 0}
                                                        renderInput={(params) => <TextField {...params} />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </div>
                    <br></br>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        Config Version <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="config-version"
                                            label="Default: 0"
                                            variant="outlined"
                                            onChange={handleConfigChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        Time RunMode <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="time-runmode"
                                            label="Default: 5"
                                            variant="outlined"
                                            onChange={handleTimeRunModeChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        Time DiffLastEvent <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="time-difflastevent"
                                            label="Default: 1440"
                                            variant="outlined"
                                            onChange={handleTimeDiffLastEventChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        BDR Timeout, ms <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="bdr-timeout"
                                            label="Default: 1000"
                                            variant="outlined"
                                            onChange={handleBDRTimeoutChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        MCU Source ID <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="mcu-source-id"
                                            label="Default: 64"
                                            variant="outlined"
                                            onChange={handleMCUSourceChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={2} md={2} lg={2}>
                            <SubCard
                                title={
                                    <span>
                                        TCU Source ID <span style={{ color: 'red' }}>*</span>
                                    </span>
                                }
                            >
                                <Grid container direction="column" spacing={2}>
                                    <Grid item>
                                        <TextField
                                            id="tcu-source-id"
                                            label="Default: 2B"
                                            variant="outlined"
                                            onChange={handleTCUSourceChange}
                                        />
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                    </Grid>
                    <br></br>
                    <Grid container spacing={6}>
                        <Grid item xs={0.5} md={1} lg={2}>
                            <Grid item>
                                <Button variant="contained" component="label" onClick={handleGetConfig}>
                                    Get Config
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={0.5} md={1} lg={2}>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    component="label"
                                    disabled={
                                        configVersion.length == 0 ||
                                        timeRunMode.length == 0 ||
                                        timeDiffLastEvent.length == 0 ||
                                        bdrTimeout.length == 0 ||
                                        mcuSource.length == 0 ||
                                        tcuSource.length == 0
                                    }
                                    onClick={handleUpdateConfig}
                                >
                                    Update Config
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br></br>
                    <div>
                        <ReusableList
                            key={content?.content?.data.length}
                            title={content.title}
                            content={content.content}
                            allowCSVExport={false}
                        ></ReusableList>
                    </div>
                </form>
            ) : (
                <div>
                    <h1>Under Development</h1>
                </div>
            )}
        </div>
    );
};

export default ConfigChecker;
